import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { GetData } from "../api/service";
import "./css/header.css";

/**
 * Site header for the student services portal.
 *
 * Deliberately mirrors the main site at rangiacollege.ac.in — black utility
 * strip, gold hairline, white brand row, navy navigation — so a student moving
 * between the two never doubts they are still on a college property.
 *
 * Links are named for what the student is trying to do, and keep the same
 * wording on the page they open.
 */
const LINKS = [
  { label: "Apply for Certificate", to: "/", exact: true },
  { label: "Certificate Status", to: "/certificate-status" },
  { label: "ID Card", to: "/idcard-request", service: "id_card" },
  { label: "Reprint Receipt", to: "/admission-print-request", service: "admission_print" },
  { label: "Verify Certificate", to: "/certificate-verfication" }
];

const MAIN_SITE = "https://rangiacollege.ac.in";

class Header extends Component {
  state = { settings: {} };

  componentDidMount() {
    GetData("/getportalsettings")
      .then((settings) => this.setState({ settings }))
      .catch(() => {});
  }

  render() {
    return (
      <header className="rc-header">
        <div className="rc-utility">
          <div className="rc-header__wrap rc-utility__inner">
            <div className="rc-utility__affil">
              Affiliated to Gauhati University
              <span className="rc-utility__meta">
                &nbsp;&nbsp;|&nbsp;&nbsp;NAAC Accredited &middot; Est. 1963
              </span>
            </div>

            <div className="rc-utility__links">
              <a className="rc-utility__link" href="tel:+919101829733">
                <i className="fa fa-phone" aria-hidden="true" />
                +91 91018 29733
              </a>
              <a
                className="rc-utility__link"
                href="mailto:principal.rangiacollege@gmail.com"
              >
                <i className="fa fa-envelope-o" aria-hidden="true" />
                principal.rangiacollege@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="rc-brandrow">
          <div className="rc-header__wrap rc-brandrow__inner">
            <NavLink to="/" className="rc-brand">
              <img
                className="rc-brand__crest"
                src="/icon192.png"
                alt="Rangia College crest"
              />
              <div className="rc-brand__text">
                <div className="rc-brand__assamese">ৰঙিয়া মহাবিদ্যালয়</div>
                <div className="rc-brand__name">Rangia College</div>
                <div className="rc-brand__tagline">
                  <span className="rc-brand__rule" />
                  Kamrup, Assam &mdash; Student Services
                </div>
              </div>
            </NavLink>

            <a
              className="rc-brandrow__cta"
              href={MAIN_SITE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-external-link" aria-hidden="true" />
              College Website
            </a>
          </div>
        </div>

        <div className="rc-navbar">
          <nav className="rc-header__wrap rc-nav" aria-label="Student services">
            {LINKS.filter((link) => this.state.settings[link.service] !== false).map((link, i) => (
              <NavLink
                key={i}
                to={link.to}
                exact={link.exact === true}
                className="rc-nav__link"
                activeClassName="rc-nav__link--active"
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;
